
function Globe(_container, _opts) {
    const opts = _opts || {};
    const container = _container;
    const colorFn = opts.colorFn || function colorFn(x) {
        const c = new THREE.Color();
        c.setHSL((0.6 - (x * 0.5)), 1.0, 0.5);
        return c;
    };
    const imgDir = opts.imgDir || '/';

    let camera;
    let scene;
    let renderer;
    let w;
    let h;
    let mesh;
    let point;
    let geometry;

    let overRenderer;

    const curZoomSpeed = 0;

    const mouse = { x: 0, y: 0 };
    const mouseOnDown = { x: 0, y: 0 };
    const rotation = { x: 0, y: 0 };
    const target = { x: Math.PI * (3 / 2), y: Math.PI / 6.0 };
    const targetOnDown = { x: 0, y: 0 };

    let distance = 100000;
    let distanceTarget = 100000;
    const PI_HALF = Math.PI / 2;

    let groupsMesh = {};
    let textLabels = [];

    function init() {
        let shader;
        let uniforms;
        let material;
        w = container.offsetWidth || window.innerWidth;
        h = container.offsetHeight || window.innerHeight;

        camera = new THREE.PerspectiveCamera(30, w / h, 1, 10000);
        camera.position.z = distance;

        scene = new THREE.Scene();

        geometry = new THREE.SphereGeometry(200, 40, 40);
        const texture = new THREE.TextureLoader().load(`${imgDir}world3.jpg`);
        // const texture = new THREE.TextureLoader().load(`${imgDir}BlankMap-Equirectangular.jpg`);
        // const texture = new THREE.TextureLoader().load(`${imgDir}earth_2009__political_by_wmediaindustries-d5rr5f7.png`);
        // texture.magFilter = THREE.NearestFilter;
        // texture.minFilter = THREE.LinearMipMapLinearFilter;

        // The base globe
        shader = Shaders.earth;
        uniforms = THREE.UniformsUtils.clone(shader.uniforms);
        uniforms.texture.value = texture;
        material = new THREE.ShaderMaterial({
            uniforms,
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
        });
        mesh = new THREE.Mesh(geometry, material);
        mesh.rotation.y = Math.PI;
        scene.add(mesh);

        // The halo
        shader = Shaders.atmosphere;
        uniforms = THREE.UniformsUtils.clone(shader.uniforms);
        material = new THREE.ShaderMaterial({
            uniforms,
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: THREE.BackSide,
            blending: THREE.SubstractiveBlending,
            transparent: true,
        });
        mesh = new THREE.Mesh(geometry, material);
        // mesh.translateZ( -50 );
        mesh.scale.set(1.1, 1.1, 1.1);
        mesh.renderOrder = 999;
        scene.add(mesh);

        // Defines 'point' mesh: used to create data lines
        const boxPoint = new THREE.BoxGeometry(0.75, 0.75, 1);
        boxPoint.applyMatrix(new THREE.Matrix4().makeTranslation(0, 0, -0.5));
        point = new THREE.Mesh(boxPoint);

        // Renderer
        renderer = new THREE.WebGLRenderer({ antialias: true });
        // renderer.autoClear = false;
        renderer.setClearColor(0xE5FFFF, 1);
        renderer.setSize(w, h);
        renderer.domElement.style.position = 'absolute';
        container.appendChild(renderer.domElement);

        // events
        document.ontouchmove = function(event){
            event.preventDefault();
        }
        container.addEventListener('touchstart', onTouchStart, false);
        container.addEventListener('mousedown', onMouseDown, false);
        container.addEventListener('mousewheel', onMouseWheel, false);
        document.addEventListener('keydown', onDocumentKeyDown, false);
        window.addEventListener('resize', onWindowResize, false);

        container.addEventListener('mouseover', () => {
            overRenderer = true;
        }, false);

        container.addEventListener('mouseout', () => {
            overRenderer = false;
        }, false);
    }

    function addDataGroups(dataGroups) {
        let lat;
        let lng;
        let size;
        let color;

        animGroups(1, 0.5, () => {
            disposeAllGroups();

            for (let j = 0; j < dataGroups.length; j += 1) {
                const currGroupName = dataGroups[j][0];
                groupsMesh[currGroupName] = new THREE.Mesh(
                    new THREE.Geometry(),
                    new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        vertexColors: THREE.FaceColors,
                        morphTargets: false,
                        transparent: true,
                    })
                );
                groupsMesh[currGroupName].scale.set(0.5, 0.5, 0.5);
                groupsMesh[currGroupName].name = currGroupName;

                const data = dataGroups[j][1];
                for (let i = 0; i < data.length; i += 3) {
                    lat = data[i] + (Math.random() - .5) * 2;
                    lng = data[i + 1];
                    color = colorFn(j);
                    size = data[i + 2];
                    size *= 200;
                    addPoint(lat, lng, size, color, groupsMesh[currGroupName].geometry);
                }
                scene.add(groupsMesh[currGroupName]);
                animGroups(0.5, 1, null);
            }
        });
    }

    function disposeAllGroups() {
        Object.keys(groupsMesh).forEach((groupName) => {
            groupsMesh[groupName].geometry.dispose();
            groupsMesh[groupName].material.dispose();
            scene.remove(groupsMesh[groupName]);
        });
        groupsMesh = {};
    }

    function addPoint(lat, lng, size, color, subgeo) {
        const phi = (90 - lat) * (Math.PI / 180);
        const theta = (180 - lng) * (Math.PI / 180);

        point.position.x = 200 * Math.sin(phi) * Math.cos(theta);
        point.position.y = 200 * Math.cos(phi);
        point.position.z = 200 * Math.sin(phi) * Math.sin(theta);

        point.lookAt(mesh.position);

        point.scale.z = Math.max(size, 0.1); // avoid non-invertible matrix
        point.updateMatrix();

        for (let i = 0; i < point.geometry.faces.length; i += 1) {
            point.geometry.faces[i].color = color;
        }

        if (point.matrixAutoUpdate) {
            point.updateMatrix();
        }
        subgeo.merge(point.geometry, point.matrix);
    }

    function updateTextLabel (labelObj) {
        /*
            https://stackoverflow.com/questions/29316832/three-js-how-to-check-if-object-is-behind-a-sphere-not-visible
        */
        const cameraToEarth = mesh.position.clone().sub(camera.position);
        const L = Math.sqrt(Math.pow(cameraToEarth.length(), 2) - Math.pow(geometry.parameters.radius, 2));
        const cameraToPin = labelObj.position.clone().sub(camera.position);
        const pos = labelObj.position.clone();
        pos.project(camera);
        pos.x = (pos.x + 1) * (w / 2);
        pos.y = (1 - pos.y) * (h / 2);
        labelObj.element.style.left = `${pos.x}px`;
        labelObj.element.style.top = `${pos.y}px`;
        const opacity = (cameraToPin.length() > L) ? 0 : 0.8;
        labelObj.element.style.opacity = opacity;
    }

    function createTextLabel(lat, lng, text, textAlt) {
        const div = document.createElement('div');
        div.className = 'text-label';
        div.classList.add('-' + text.toLowerCase().replace(/ /g, '-'));
        div.innerHTML = textAlt;
        div.style.position = 'absolute';
        div.style.top = '-2500px';
        div.style.left = '-2500px';
        container.appendChild(div);

        const phi = (90 - lat) * (Math.PI / 180);
        const theta = (180 - lng) * (Math.PI / 180);

        const position = new THREE.Vector3(0, 0, 0);
        position.x = 200 * Math.sin(phi) * Math.cos(theta);
        position.y = 200 * Math.cos(phi);
        position.z = 200 * Math.sin(phi) * Math.sin(theta);

        textLabels.push({
            text: text,
            element: div,
            position,
            angle: 0,
            radius: 50,
            w: div.offsetWidth,
            h: div.offsetHeight,
        });
    }

    function getTextLabels () {
        return textLabels;
    }

    function clearTextLabels () {
        textLabels.forEach(label => label.element.parentNode.removeChild(label.element));
        textLabels = [];
    }

    function animGroups(start, end, callback) {
        const scale = { val: start };
        new TWEEN.Tween(scale)
            .to({ val: end }, 500)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(() => {
                Object.keys(groupsMesh).forEach((groupName) => {
                    groupsMesh[groupName].scale.set(scale.val, scale.val, scale.val);
                });
            })
            .onComplete(callback)
            .start();
    }

    function highlightGroup(keepGroupName) {
        Object.keys(groupsMesh).forEach((groupName) => {
            if (keepGroupName === '' || groupName === keepGroupName) {
                groupsMesh[groupName].visible = true;
            } else {
                groupsMesh[groupName].visible = false;
            }
        });
    }

    function onTouchStart(event) {
        event.preventDefault();
        if (event.touches.length) {
            container.addEventListener('touchmove', onTouchMove, false);
            container.addEventListener('touchcancel', onTouchEnd, false);
            container.addEventListener('touchend', onTouchEnd, false);

            mouseOnDown.x = -event.touches[0].clientX;
            mouseOnDown.y = event.touches[0].clientY;

            targetOnDown.x = target.x;
            targetOnDown.y = target.y;

            // container.style.cursor = 'move';
        }
    }

    function onMouseDown(event) {
        event.preventDefault();

        container.addEventListener('mousemove', onMouseMove, false);
        container.addEventListener('mouseup', onMouseUp, false);
        container.addEventListener('mouseout', onMouseOut, false);

        mouseOnDown.x = -event.clientX;
        mouseOnDown.y = event.clientY;

        targetOnDown.x = target.x;
        targetOnDown.y = target.y;

        container.style.cursor = 'move';
    }

    function onMouseMove(event) {
        mouse.x = -event.clientX;
        mouse.y = event.clientY;

        const zoomDamp = distance / 1000;

        target.x = targetOnDown.x + ((mouse.x - mouseOnDown.x) * 0.005 * zoomDamp);
        target.y = targetOnDown.y + ((mouse.y - mouseOnDown.y) * 0.005 * zoomDamp);

        target.y = target.y > PI_HALF ? PI_HALF : target.y;
        target.y = target.y < -PI_HALF ? -PI_HALF : target.y;
    }

    function onTouchMove(event) {
        mouse.x = -event.touches[0].clientX;
        mouse.y = event.touches[0].clientY;

        const zoomDamp = distance / 1000;

        target.x = targetOnDown.x + ((mouse.x - mouseOnDown.x) * 0.005 * zoomDamp);
        target.y = targetOnDown.y + ((mouse.y - mouseOnDown.y) * 0.005 * zoomDamp);

        target.y = target.y > PI_HALF ? PI_HALF : target.y;
        target.y = target.y < -PI_HALF ? -PI_HALF : target.y;
    }

    function onTouchEnd() {
        container.removeEventListener('touchmove', onTouchMove, false);
        container.removeEventListener('touchcancel', onTouchEnd, false);
        container.removeEventListener('touchend', onTouchEnd, false);
    }

    function onMouseUp() {
        container.removeEventListener('mousemove', onMouseMove, false);
        container.removeEventListener('mouseup', onMouseUp, false);
        container.removeEventListener('mouseout', onMouseOut, false);
        container.style.cursor = 'auto';
    }

    function onMouseOut() {
        container.removeEventListener('mousemove', onMouseMove, false);
        container.removeEventListener('mouseup', onMouseUp, false);
        container.removeEventListener('mouseout', onMouseOut, false);
    }

    function onMouseWheel(event) {
        event.preventDefault();
        if (overRenderer) {
            zoom(event.wheelDeltaY * 0.3);
        }
        return false;
    }

    function onDocumentKeyDown(event) {
        switch (event.keyCode) {
            case 38:
                zoom(100);
                event.preventDefault();
                break;
            case 40:
                zoom(-100);
                event.preventDefault();
                break;
            default:
                break;
        }
    }

    function onWindowResize() {
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();
        w = container.offsetWidth;
        h = container.offsetHeight;
        renderer.setSize(container.offsetWidth, container.offsetHeight);
    }

    function zoom(delta) {
        distanceTarget -= delta;
        distanceTarget = distanceTarget > 1000 ? 1000 : distanceTarget;
        distanceTarget = distanceTarget < 500 ? 500 : distanceTarget;
    }

    function animate() {
        setTimeout( function() {
            requestAnimationFrame( animate );
        }, 1000 / 30 );
        TWEEN.update();
        render();
    }

    function updateTarget(lat, lng) {
        target.x = (lng + 270) * (Math.PI / 180);
        target.y = (lat - 10) * (Math.PI / 180);
    }

    function updateZoom(_zoom) {
        distanceTarget = _zoom;
    }

    function render() {
        zoom(curZoomSpeed);

        rotation.x += (target.x - rotation.x) * 0.1;
        rotation.y += (target.y - rotation.y) * 0.1;
        distance += (distanceTarget - distance) * 0.3;

        camera.position.x = distance * Math.sin(rotation.x) * Math.cos(rotation.y);
        camera.position.y = distance * Math.sin(rotation.y);
        camera.position.z = distance * Math.cos(rotation.x) * Math.cos(rotation.y);

        camera.lookAt(mesh.position);

        textLabels.forEach(updateTextLabel);

        renderer.render(scene, camera);
    }

    init();

    this.animate = animate;

    this.addDataGroups = addDataGroups;
    this.renderer = renderer;
    this.scene = scene;
    this.updateTarget = updateTarget;
    this.updateZoom = updateZoom;
    this.zoom = zoom;
    this.highlightGroup = highlightGroup;
    this.createTextLabel = createTextLabel;
    this.getTextLabels = getTextLabels;
    this.clearTextLabels = clearTextLabels;

    return this;
}
